import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'next/image';
import spiritoryLogo from '@/public/images/icons/auth/spiritory_white_logo.svg';
import styles from './authLayout.module.scss';
import Link from 'next/link';
import translationFallback from '@/utilites/translations/translationFallback';
import { useTranslation } from 'next-i18next';
import useWindowWidth from '@/hooks/useWindowWidth';
import ResponsiveComponent from '../common/ResponsiveComponent';
import { AuthLayoutProps } from '@/types/other';

const AuthLayout = ({ children, windowWidthSv = null }: AuthLayoutProps) => {
  const { t } = useTranslation('index');
  const { t: tCommon } = useTranslation('common');
  const { t: tDashboard } = useTranslation('dashboard');
  const windowWidth = useWindowWidth(windowWidthSv);

  return (
    <ResponsiveComponent
      windowWidth={windowWidth}
      MobileComponent={<main>{children}</main>}
      DesktopComponent={
        <Row className="g-0">
          <Col
            lg={3}
            md={2}
            className={`position-fixed bg-primary vh-100 ${styles.authBackground}`}
          >
            <div
              className="d-flex flex-column align-items-center"
              id={styles.logoAuth}
            >
              <Image
                src={spiritoryLogo}
                width={310}
                height={0}
                alt="Spiritory Logo"
              />
              <div
                id={styles.authProcess}
                className=" text-white mt-9"
                style={{ fontWeight: 'bolder' }}
              >
                {translationFallback(
                  'authentication',
                  tCommon('authentication'),
                  'Authentication'
                )}{' '}
                <br />
                {translationFallback(
                  'authentication.process',
                  tDashboard('authentication.process'),
                  'process'
                )}
              </div>
            </div>
            <div className={styles.finalText}>
              <Link href={'/authenticating'}>
                {' '}
                {translationFallback(
                  'authentication.about_authentication',
                  tDashboard('authentication.about_authentication'),
                  'About Authentication'
                )}
              </Link>
              <span>|</span>
              <Link href={'/data-privacy'}>
                {translationFallback(
                  'authentication.privacy',
                  tDashboard('authentication.privacy'),
                  'Privacy'
                )}
              </Link>
            </div>
          </Col>
          <Col
            lg={{ span: 9, offset: 3 }}
            md={{ span: 10, offset: 2 }}
            className="vh-100 overflow-y-auto overflow-x-hidden"
          >
            {children}
          </Col>
        </Row>
      }
    />
  );
};

export default AuthLayout;
